import React, { useEffect, useRef, useState } from "react"
import RemoveIcon from "../../images/remove-search.svg"
import PropTypes from "prop-types"
import { Overlay, OverlayTrigger, Popover } from "react-bootstrap"

const FilterSelect = ({ options, placeholder, name, selectedOptions, className, setQuery }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [selected, setSelected] = useState([])
    const ref = useRef(null)

    const findSelected = (selectedOptions, options) => {
        return options?.filter(o => (selectedOptions?.find(s => s === o.id) ? o : false))
    }

    useEffect(() => {
        if (selectedOptions?.length && options?.length) {
            const selectedItems = findSelected(selectedOptions, options)
            setSelected(selectedItems)
        }
        if (!selectedOptions?.length) setSelected([])
    }, [selectedOptions, options])

    const onSelect = item => {
        setIsOpen(false)
        setQuery({ [`${name}`]: [...selectedOptions, item.id], page: 1 })
    }

    const onDeleteItem = id => {
        setQuery({ [`${name}`]: selectedOptions.filter(s => s !== id), page: 1 })
    }

    return (
        <div ref={ref} className={`dropdown dropdown-bookings show me-3 mt-2 ${className ?? ""}`}>
            <div className="btn d-flex">
                {selected?.length ? (
                    selected?.map(i => (
                        <div key={i.id} className="selected-title me-2">
                            <div title={i.name}>
                                {i.name?.length > 15 ? i.name?.slice(0, 13) + "..." : i?.name}
                                <button onClick={() => onDeleteItem(i.id)}>
                                    <img src={RemoveIcon} alt="Remove Icon" />
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div onClick={() => setIsOpen(!isOpen)} role="button">
                        {placeholder}
                    </div>
                )}

                <div className="select-arrow-wrapper" role="button" onClick={() => setIsOpen(!isOpen)}>
                    <svg
                        className={`arrow-select ${isOpen ? "open" : ""}`}
                        width="9"
                        height="5"
                        viewBox="0 0 9 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.895925 4.7813L0.117421 4.06899L4.51574 0.0446429L8.91406 4.06899L8.13556 4.7813L4.51574 1.46926L0.895925 4.7813Z"
                            fill="#616371"
                        />
                    </svg>
                </div>
            </div>

            {typeof window !== "undefined" && (
                <Overlay show={isOpen} trigger="click" rootClose target={ref} placement="bottom" onHide={() => setIsOpen(false)}>
                    <div className="dropdown-menu show">
                        {options.map(o => (
                            <div role="button" title={o.name} onClick={() => onSelect(o)} className="dropdown-item" key={o.id}>
                                {o.name}
                            </div>
                        ))}
                    </div>
                </Overlay>
            )}
        </div>
    )
}

FilterSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    placeholder: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selectedOptions: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default FilterSelect
